module.exports = __webpack_public_path__ + "static/media/logo-yoho.ef4f9457.png";